import { createFileRoute } from '@tanstack/react-router'

import { VehicleDetail } from '@/features/vehicles/vehicle-detail'

export const Route = createFileRoute('/_app/vehicles/$vehicleId')({
  component: VehicleDetail,
})
